export default __webpack_public_path__ + "media/images/ui-bg_highlight-soft_25_ffef8f_1x100-d3cce7d7f63d015cdb0b56941d581060.png";